import React from "react";
import "./logo.scss";
import LogoImage from "./images/logo.svg";

const Logo = () => {
  return (
    <>
      <img src={LogoImage} className="logo" alt="The Best Logo In the World" />
    </>
  );
};

export default Logo;
